






import Vue from 'vue';

export default Vue.extend({
  name: 'admin-test-index',
});
